module.exports = { "default": require("core-js/library/fn/string/raw"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/string/raw.js
// module id = 713
// module chunks = 0